var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33301 21.5V19.1667H2.66634C2.02467 19.1667 1.47556 18.9384 1.01901 18.4818C0.561675 18.0245 0.333008 17.475 0.333008 16.8333V2.83333C0.333008 2.19167 0.561675 1.64217 1.01901 1.18483C1.47556 0.728278 2.02467 0.5 2.66634 0.5H11.9997V2.83333H2.66634V16.8333H21.333V13.3333H23.6663V16.8333C23.6663 17.475 23.4381 18.0245 22.9815 18.4818C22.5242 18.9384 21.9747 19.1667 21.333 19.1667H16.6663V21.5H7.33301ZM17.833 13.3333L11.9997 7.5L13.633 5.86667L16.6663 8.87083V0.5H18.9997V8.87083L22.033 5.86667L23.6663 7.5L17.833 13.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstall);
export default __webpack_public_path__ + "static/media/install.c9b26d5638858d801485aaceb47e87a3.svg";
export { ForwardRef as ReactComponent };